'use strict';

const { pubdb } = Function('return this')();
const { $, window, ajax_get, echo, path_root, mustache, next_tick, smart_sort } = pubdb;
const { alert, parent } = window;

$(function () {
// everything's in $(...) {{{


const select_we = $('#select_we');

let forschungsprojekts = [];
let last_id = -1;


function fp_list_success (data) {
    forschungsprojekts = data;

    next_tick(function () {
        window.focus();
    });

    let we = 0;
    try {
        we = parent.pub.we;
    } catch (ex) {
        // void
    }

    select_we.attr('disabled', false);
    if (we) {
        select_we.val(we);
    }
    on_change_we();
}


function fp_list_error (data, err, xhr) {
    echo('warn', 'Fehler (' + data.statusText + ') ist beim Laden der Forschungsprojekte aufgetreten - bitte versuchen Sie es erneut');
}


function on_change_we () {
    const id = +select_we.val();
    if (!id || id === last_id) {
        return;
    }
    last_id = id;

    const list = [];
    const { length } = forschungsprojekts;
    for (let i = 0; i < length; ++i) {
        const forschungsprojekt = forschungsprojekts[i];
        if (forschungsprojekt.we === id) {
            list.push(forschungsprojekt);
        }
    }
    list.sort((a, b) => smart_sort((a || {}).sort_ger, (b || {}).sort_ger));

    $('#pubdb_data').html(mustache(
        '<ul>' +
            '{{#list}}' +
                '<li>' +
                    '<label style="font-weight:normal">' +
                        '<input type="radio" name="choose" value="{{id}}" /> ' +
                        '{{#titel_ger}}{{titel_ger}}{{/titel_ger}}' +
                        '{{^titel_ger}}{{titel_eng}}{{/titel_ger}}' +
                    '</label>' +
                '</li>' +
            '{{/}}' +
            '{{^list}}' +
                '<li style="list-style:none;">' +
                    '<strong>Es wurden noch keine Forschungsprojekte für „{{we}}“ eingetragen.</strong>' +
                '</li>' +
            '{{/}}' +
        '</ul>',
        {list, we:$(':selected', this).text()}
    ));
}


select_we.on('change blur keyup', on_change_we).attr('disabled', true);

$('#main_form').on('submit', function (ev) {
    ev.preventDefault();
});

$('#chose_project').on('click', function (ev) {
    ev.preventDefault();

    const cur = $('#pubdb_data :checked');
    if(!cur.length) {
        alert('Sie haben kein Projekt ausgewählt.');
        return;
    }

    const id = +cur.val();
    var found = false;
    for (let i = 0, { length } = forschungsprojekts; i < length; ++i) {
        const forschungsprojekt = forschungsprojekts[i];
        if (forschungsprojekt.id === id) {
            window[pubdb.callback](forschungsprojekt);
            found = true;
            break;
        }
    }

    if (!found) {
        alert('Interner Fehler: Id=' + id + ' wurde nicht gefunden.');
        window[pubdb.callback](null);
    }
});

$('#reset_project').on('click', function (ev) {
    ev.preventDefault();
    window[pubdb.callback](null);
});

$('#new_project').on('click', function (ev) {
    ev.preventDefault();

    let iframe = parent.pubdb.iframe_dialog(
        path_root + '/forschungsprojekt/new/?content_only&callback=created_fp',
        'Neues Forschungsprojekt anlegen',
        onload,
        onunload,
    );

    function onload (cW) {
        cW.created_fp = created_fp;
    }

    function onunload (cW) {
        if (!iframe) {
            return;
        }
        iframe.dialog('close');
        iframe = null;
    }

    function created_fp (data) {
        if (!data) {
            return;
        }
        window[pubdb.callback](data);
        onunload();
    }
});

ajax_get(path_root + '/forschungsprojekt/list/', fp_list_success, fp_list_error);


// }}} everything's in $(...)
});
